
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() addType!: string;
  model = {
    rulerValue: '',
  };
  @Emit() close() {}
  title: string = this.addType == 'phone' ? '手机号/号段' : 'IP/IP段';
  rules = {
    rulerValue: [{ required: true, message: '请输入' + this.title, trigger: 'blur' }],
  };
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid);

      if (valid) {
        this.$emit('submit', this.model.rulerValue);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
}
